import { useEffect, useMemo, useRef } from 'react'
import { StatPreviewCard } from '../stat-preview-card/stat-preview-card'
import './stat-preview.scss'
import { StatItem } from '../../../../../Models'

interface StatPreviewProps {
  items: StatItem[]
  editingId: string | null
}

export function StatPreview({ items, editingId }: StatPreviewProps) {
  const itemRefs = useRef(new Map<string, HTMLLIElement>())

  // Mirror the landing page: hidden stats are not rendered. The one being
  // edited is still shown (flagged as hidden) so its changes stay visible.
  const shown = useMemo(
    () => items.filter((item) => item.visible || item.id === editingId),
    [items, editingId],
  )
  const hiddenCount = items.filter((item) => !item.visible).length

  return (
    <aside className='stat-preview' aria-labelledby='stat-preview-title'>
      <h3 className='stat-preview__title' id='stat-preview-title'>
        Live preview
      </h3>

      {shown.length === 0 ? (
        <p className='stat-preview__empty'>No stats are visible on the landing page.</p>
      ) : (
        <ul className='stat-preview__list'>
          {shown.map((item) => (
            <li
              key={item.id}
              className='stat-preview__item'
              ref={(element) => {
                if (element) {
                  itemRefs.current.set(item.id, element)
                } else {
                  itemRefs.current.delete(item.id)
                }
              }}
            >
              <StatPreviewCard item={item} isActive={item.id === editingId} />
            </li>
          ))}
        </ul>
      )}

      {hiddenCount > 0 && (
        <p className='stat-preview__footnote'>
          {hiddenCount} {hiddenCount === 1 ? 'stat is' : 'stats are'} hidden from the landing page.
        </p>
      )}
    </aside>
  )
}
